import { render } from "./Resolutions.vue?vue&type=template&id=7abccbe4&scoped=true"
import script from "./Resolutions.vue?vue&type=script&lang=js"
export * from "./Resolutions.vue?vue&type=script&lang=js"

import "./Resolutions.vue?vue&type=style&index=0&id=7abccbe4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abccbe4"]])

export default __exports__